
    import './styles.scoped.css';
    export default {
  "empty-appear": "awsui_empty-appear_n4qlp_vymdx_13",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_n4qlp_vymdx_1",
  "root": "awsui_root_n4qlp_vymdx_35",
  "empty": "awsui_empty_n4qlp_vymdx_13",
  "row": "awsui_row_n4qlp_vymdx_81",
  "divider": "awsui_divider_n4qlp_vymdx_85",
  "row-control": "awsui_row-control_n4qlp_vymdx_90",
  "field": "awsui_field_n4qlp_vymdx_94",
  "additional-info": "awsui_additional-info_n4qlp_vymdx_98",
  "add-row": "awsui_add-row_n4qlp_vymdx_145",
  "add-button": "awsui_add-button_n4qlp_vymdx_149",
  "remove-button-container": "awsui_remove-button-container_n4qlp_vymdx_153",
  "remove-button-field-padding": "awsui_remove-button-field-padding_n4qlp_vymdx_157",
  "remove-button-own-row": "awsui_remove-button-own-row_n4qlp_vymdx_161",
  "remove-button": "awsui_remove-button_n4qlp_vymdx_153"
};
  